// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_7jNG4HN2qNnHn5Rd5BOyn","Dell":"_3LHkVeYR9SLQ2xTUvSuFdm","Abbott":"_2T_X3QwFMdLQg-4mPeeuFi","Gap":"_2_mFuglw_dCViOqh9X9THO","Allstate":"_2MDB6gJMJES9D4YS8kZZaO","Asurion":"_3l8Q_-YP9gpqvvM3hDmEQV","Invitae":"AFPa9C_Y5PZASWZgvTCMd","JWE":"_3EN6d0yz9kXuz6QfPUqFZO"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/main.scss
// module id = JD12
// module chunks = 12